import styled from '@emotion/styled';
import Button from '@base/Button/Button';
import ChevronDown from '@icon/ChevronDown';
import { useState } from 'react';
import Typography from 'aquilla/core/atoms/Typography';
import { Spacings, Fonts, mediaQuery } from '@styles/index';

const StyButton = styled(Button)`
  border-radius: ${Spacings.SPACING_6B};
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.SEMIBOLD};
  width: 150px;
  height: ${Spacings.SPACING_9B};
  min-height: unset;
  display: flex;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
`;

const StyIcon = styled(ChevronDown)`
  margin-top: ${Spacings.SPACING_1B};
  width: ${Spacings.SPACING_4B};
  height: ${Spacings.SPACING_4B};
  margin-right: -${Spacings.SPACING_1B};
`;

const ModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const ListWrapper = styled.div`
  max-height: 200px;
  width: calc(100vw - ${Spacings.SPACING_8B});
  background: var(--color-base-1);
  margin-bottom: ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_4B};
  overflow-x: scroll;
`;

const ActiveIcon = styled.div`
  width: ${Spacings.SPACING_6};
  height: ${Spacings.SPACING_6};
  border-radius: 50%;
  background: var(--color-i-green);
`;

const Container = styled.div`
  ${mediaQuery.aboveMobile} {
    visibility: hidden;
  }
`;

const ListOption = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_2B} 0;

  p {
    font-weight: ${({ $isActive }) =>
      $isActive ? Fonts.SEMIBOLD : Fonts.LIGHT};
  }
  div {
    visibility: ${({ $isActive }) => ($isActive ? 'visible' : 'hidden')};
  }
`;

const JumpToSelector = ({ weekDetails, onWeekSelect, selectedWeek }) => {
  const [openSelector, setOpenSelector] = useState(false);

  const handleOpenSelector = () => {
    setOpenSelector(!openSelector);
  };

  const handleWeekSelect = (week) => () => {
    if (week !== selectedWeek) onWeekSelect(week);
  };

  return (
    <Container>
      <ButtonWrapper>
        <StyButton
          color="black"
          label="Jump To Week"
          icon={<StyIcon color="white" />}
          onClick={handleOpenSelector}
        />
      </ButtonWrapper>
      {openSelector && (
        <ModalWrapper onClick={handleOpenSelector}>
          <ListWrapper>
            {weekDetails.map((week) => (
              <ListOption
                key={week.weekNumber}
                onClick={handleWeekSelect(week.weekNumber)}
                $isActive={selectedWeek === week.weekNumber}
              >
                <ActiveIcon />
                <Typography variant="p2">Week {week.weekNumber}</Typography>
              </ListOption>
            ))}
          </ListWrapper>
        </ModalWrapper>
      )}
    </Container>
  );
};

export default JumpToSelector;
